import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBodyFlowOne from "./Grid/GridBodyFlowOne";
import withRouter from "../../components/Common/withRouter";
import { DF_OT0011Context } from "./context";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";
import { useSelector } from "react-redux";
import GridBodyFlowTwo from "./Grid/GridBodyFlowTwo";

function DF_OT0011(props) {
  document.title = "Defender | Criar Pré-Agendamento";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);
  const [paramsOnFilter, setParamsOnFilter] = React.useState([]);
  const csrfToken = useGetCsrfToken();

  const ID_Agendamento = parseParams.get("ID_Agendamento") || null; 

  const { access_token, userProfile } = useSelector((state) => ({
      access_token: state.login.user?.access_token,
      userProfile: state.login.profile,
    }));

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_OT0011Context.Provider
        value={{
          parseParams,
          paramsOnFilter,
          setParamsOnFilter,
          csrfToken,
          access_token,
          userProfile,
          ID_Agendamento
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader hasIdAgendamento={ID_Agendamento} />
            {ID_Agendamento ? <GridBodyFlowTwo /> : <GridBodyFlowOne />}
          </Container>
        </div>
      </DF_OT0011Context.Provider>
    </>
  );
}

export default withRouter(DF_OT0011);
